import { PartnerConfiguration } from '@percent/education-hosted-form/api/partnerConfig/partnerConfig.types'

// Currently only NSC for students, which require Date of Birth
export const shouldRunEnrolmentCheck = (configuration?: PartnerConfiguration['configuration']) =>
  !!configuration?.externalAgentVerificationEnabled && configuration?.education?.eduHostedFormType === 'student'
